import { Component, OnInit, Input } from "@angular/core";
import _ from "lodash";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { NzModalRef } from "ng-zorro-antd/modal";
import { NzMessageService } from "ng-zorro-antd/message";

import { DialogueSettingService } from "../../../message/dialogue-setting.service";
import { TranslateService } from "@root/shared/service/translate.service";
import { RateTemplateService } from "@root/router/rate/rate-template/rate-template.service";
/** @TODO: y移走，重命名 */
@Component({
  selector: "host-add-quick-message-group",
  templateUrl: "./add-quick-message-group.component.html",
  styleUrls: ["./add-quick-message-group.component.scss"],
})
export class AddQuickMessageGroupComponent implements OnInit {
  @Input() isSubAccount = false;
  @Input() group;
  @Input() titleList = [];
  @Input() template: 'message' | 'rate' = 'message';
  form: UntypedFormGroup = this.fb.group({
    name: null,
    scope: 0,
  });
  checking = false;
  constructor(
    private fb: UntypedFormBuilder,
    private dialogueSettingService: DialogueSettingService,
    private rateService: RateTemplateService,
    private modalRef: NzModalRef,
    private messageService: NzMessageService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    if (this.group) {
      this.initGroup();
    }
  }

  initGroup() {
    this.form.patchValue({
      name: this.group.name,
      scope: this.group.scope,
    });
  }

  save() {
    this.checking = true;
    if (!this.checkValid()) {
      return;
    }
    if (this.group) {
      this.editGroup();
    } else {
      this.createGroup();
    }
  }

  private editMessageGroup (params) {
    this.dialogueSettingService.updateQuickMessageGroup(params).subscribe((res) => {
      if (res.error_code === 0) {
        // 修改成功！
        const successText = this.translateService.syncGet("success.modify");
        this.messageService.success(successText);
        this.modalRef.triggerOk();
        this.modalRef.destroy();
      }
    });
  }

  private editRateGroup (params) {
    this.rateService.updateGroup(params).subscribe(res => {
      if (res.error_code === 0) {
        // 修改成功！
        const successText = this.translateService.syncGet("success.modify");
        this.messageService.success(successText);
        this.modalRef.triggerOk();
        this.modalRef.destroy();
      }
    });
  }

  private createMessageGroup (params) {
    this.dialogueSettingService.addQuickMessageGroup(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.modalRef.triggerOk();
        this.modalRef.destroy();
      }
    });
  }

  private createRateGroup (params) {
    this.rateService.createGroup(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.modalRef.triggerOk();
        this.modalRef.destroy();
      }
    });
  }

  createGroup() {
    const params = {
      name: this.form.value.name,
      scope: this.isSubAccount ? 0 : this.form.value.scope,
    };
    if (this.template === 'message') {
      this.createMessageGroup(params);
    } else {
      this.createRateGroup(params);
    }
  }

  editGroup() {
    if (this.judgeNameExisted()) {
      return;
    }
    const params = {
      id: this.group.id,
      name: this.form.value.name,
      scope: this.isSubAccount ? 0 : this.form.value.scope,
    };

    if (this.template === 'message') {
      this.editMessageGroup(params);
    } else {
      this.editRateGroup(params);
    }

  }

  judgeNameExisted() {
    const name = this.form.value.name;
    const groupName = _.find(this.titleList, (title) => title === name);
    if (groupName && name !== this.group.name) {
      // 该名称已存在
      const warningText = this.translateService.syncGet(
        "dialogue_setting.group_name_existed"
      );
      this.messageService.warning(warningText);
      return true;
    }
    return false;
  }



  cancel() {
    this.modalRef.destroy();
  }

  checkValid() {
    const value = this.form.value;
    if (!value.name || value.name === "") {
      return false;
    }
    return true;
  }
}
